module.exports = __webpack_public_path__ + "media/images/lp_v6_img03-a8fdb86e12797882ff602a7c35ee0a00.png";